export default function () {
    const notResolved = {
        key: 'notResolved',
        value: 0,
        description: 'Discrepancy stands'
    };

    const resolved = {
        key: 'resolved',
        value: 100,
        description: 'Discrepancy cleared'
    };

    return arrayToEnum([
        notResolved,
        resolved
    ]);
}

function arrayToEnum(arr) {
    const toReturn = {};

    arr.forEach(x => {
        toReturn[x.key] = x;

        Object.defineProperty(toReturn, x.value, {
            enumerable: false,
            value: x
        });
    });

    return toReturn;
}



// WEBPACK FOOTER //
// ./Client/app/tasks/services/discrepancies/discrepancyResolvedState.js